let {
  isDebuggerProduction,
  proxySetting,
  isProxy,
  buildForTest,
  lastUpdateDateTime
} = require('./devConfig.js');
let mock = false;
let baseURL;
let platform = 45;

let isDev = process.env.NODE_ENV != 'production';

const buildArg = process.env.BUILD_ARG;
if (buildArg == 'test') {
  isProxy = false;
  isDev = true;
} else if (buildArg == 'prod') {
  // isProxy = false;
}

if (isDev) {
  baseURL = isProxy ? '/api' : '//api.book.com';
} else {
  baseURL = '//api.elfinbook.com/';
}

let redirectURL = '//www.elfinbook.com';
let isMockData = isDev && false;
let isDevPrintLog = isDev && false;

let isShapeFillWhite = false; // 形状sku是否填充白色

export const imageWithWhiteInkDefaultOpacity = 0.7; // 有白墨的图片默认前景透明度

console.log(`当前环境参数:${buildArg} ,接口= ${baseURL}`); // 输出test或prod

export {
  mock,
  baseURL,
  redirectURL,
  platform,
  isDebuggerProduction,
  isMockData,
  proxySetting,
  isDev,
  isDevPrintLog,
  isShapeFillWhite,
  lastUpdateDateTime
};
